module.exports = __webpack_public_path__ + "static/img/senbole-logo-mark.47481414.png";